module.exports = __webpack_public_path__ + "img/7-ELEVEN.73cf372d.svg";